import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'

const ModalAsignaturas = ({ open, onClose, name, asignaturas = [] }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>{name}</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Asignatura</TableCell>
                <TableCell>Nivel</TableCell>
                <TableCell>Subnivel</TableCell>
                <TableCell>Tipo</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {asignaturas.map((asignatura, index) => (
                <TableRow key={index}>
                  <TableCell>{asignatura.nombre || '--'}</TableCell>
                  <TableCell>{asignatura.nivel || '--'}</TableCell>
                  <TableCell>{asignatura.subnivel || '--'}</TableCell>
                  <TableCell>{asignatura.tipo || '--'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalAsignaturas
